require('lightgallery')

$(document).ready(function() {
    $("#lightgallery").lightGallery();
    $("#lightgallery2").lightGallery({
        selector: ".openLightGallery"
    });
});
